import { Component, OnInit, ChangeDetectorRef, inject } from '@angular/core';
import { SuggestionEngineService } from '../../suggestion-engine/suggestion-engine.service';
import { SessionStorageService } from '../../services/session-storage.service';
import { DateTime } from 'luxon';
import { Router } from '@angular/router';
import { Message } from '../../models/suggestion-engine-models';

import { SummaryChartsComponent } from '../widgets/summaryCharts/summaryCharts.component';
import { SystemUsageSummaryComponent } from '../widgets/systemUsageSummary/systemUsageSummary.component';
import { CasesByScoreclassComponent } from '../widgets/casesByScoreclass/casesByScoreclass.component';
import { Top5SummaryComponent } from '../widgets/top5Summary/top5Summary.component';
import { LegacyAppLinksComponent } from '../widgets/legacy-app-links/legacy-app-links.component';
import { CaseStatsComponent } from '../widgets/caseStats/caseStats.component';
import { HighActivityStatsComponent } from '../widgets/highActivityStats/highActivityStats.component';
import { FundComparisonComponent } from '../widgets/fund-comparison/fund-comparison.component';
import { UnitProductStatsComponent } from '../widgets/unitProductStats/unitProductStats.component';
import { LifeStatsComponent } from '../widgets/life-stats/life-stats.component';
import { Top5Component } from '../widgets/top5/top5.component';
import { TopOppsComponent } from '../widgets/top-opps/top-opps.component';
import { TimeSensitiveComponent } from '../widgets/time-sensitive/time-sensitive.component';
import { FollowUpComponent } from '../widgets/followUp/followUp.component';
import { ScorecardComponent } from '../widgets/scorecard/scorecard.component';
import { AnnuitiesComponent } from '../widgets/annuities/annuities.component';
import { FixedAnnuitiesActiveRatesComponent } from '../widgets/fixed-annuities-active-rates/fixed-annuities-active-rates.component';
import { TopBridgesComponent } from '../widgets/topBridges/topBridges.component';
import { FiaRatesComponent } from '../widgets/fia-rates/fia-rates.component';
import { FiaActiveRatesComponent } from '../widgets/fiaactiverates/fiaactiverates.component';
import { ViaRatesComponent } from '../widgets/via-rates/via-rates.component';
import { ViaActiveRatesComponent } from '../widgets/via-active-rates/via-active-rates.component';
import { PpfaComponent } from '../widgets/ppfa/ppfa.component';
import { ActivePPfaComponent } from '../widgets/activeppfa/activeppfa.component';
import { AnnuitiesByConnectorComponent } from '../widgets/annuities-by-connector/annuities-by-connector.component';
import { LivingBenefitsComponent } from '../widgets/living-benefits/living-benefits.component';
import { DeathBenefitsComponent } from '../widgets/death-benefits/death-benefits.component';
import { UploaderComponent } from '../widgets/uploader/uploader.component';
import { MessagesComponent } from '../widgets/messages/messages.component';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideLuxonDateAdapter } from '@angular/material-luxon-adapter';

@Component({
  selector: 'app-se-dashboard',
  templateUrl: './se-dashboard.component.html',
  styleUrls: ['../dashboard.component.scss'],
  imports: [
    SummaryChartsComponent,
    SystemUsageSummaryComponent,
    CasesByScoreclassComponent,
    Top5SummaryComponent,
    LegacyAppLinksComponent,
    CaseStatsComponent,
    HighActivityStatsComponent,
    FundComparisonComponent,
    UnitProductStatsComponent,
    LifeStatsComponent,
    Top5Component,
    TopOppsComponent,
    TimeSensitiveComponent,
    FollowUpComponent,
    ScorecardComponent,
    AnnuitiesComponent,
    FixedAnnuitiesActiveRatesComponent,
    TopBridgesComponent,
    FiaRatesComponent,
    FiaActiveRatesComponent,
    ViaRatesComponent,
    ViaActiveRatesComponent,
    PpfaComponent,
    ActivePPfaComponent,
    AnnuitiesByConnectorComponent,
    LivingBenefitsComponent,
    DeathBenefitsComponent,
    UploaderComponent,
    MessagesComponent,
    CommonModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [provideLuxonDateAdapter()],
})
export class SeDashboardComponent implements OnInit {
  private cdRef = inject(ChangeDetectorRef);
  private ses = inject(SuggestionEngineService);
  private ss = inject(SessionStorageService);
  private route = inject(Router);

  msgContent: Message[] = [];
  app = this.ss.get('currentApp');
  solutions = [{ label: 'All', value: 'ALL' }];
  solution = 'ALL';
  unit = this.ss.get('firm');
  startDate = DateTime.now().minus({ days: 30 }).toUTC().toISO();
  endDate = DateTime.now().toUTC().toISO();
  rights = this.ss.get('rights');
  loading = false;

  ngOnInit() {
    this.ses.getMessages().subscribe((msgs: { messages: Message[] }) => {
      this.msgContent = msgs.messages;
    });

    this.ss.get('globals')?.Modules.forEach(el => {
      switch (el.toLowerCase()) {
        case 'aw':
          this.solutions.push({
            label: 'Annuity Wizard',
            value: el.toLowerCase(),
          });
          break;
        case 'iw':
          this.solutions.push({
            label: 'Investment Wizard',
            value: el.toLowerCase(),
          });
          break;
        case 'li':
          this.solutions.push({
            label: 'Life Insurance Wizard',
            value: el.toLowerCase(),
          });
          break;
        case 'pp':
          this.solutions.push({
            label: 'Product Profiler',
            value: el.toLowerCase(),
          });
          break;
        default:
          break;
      }
    });

    this.solution = this.solutions[0].value;
  }

  hasMessages(messageWidgetNum) {
    const messageContentIndex = messageWidgetNum - 1;
    return (
      this.rights?.includes(`MessagesWidget${messageWidgetNum}`) &&
      this.msgContent &&
      this.msgContent[messageContentIndex] &&
      this.msgContent[messageContentIndex].title
    );
  }

  nav(location) {
    this.route.navigate([`/${location}`]);
  }

  solutionChange(ev) {
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
      this.cdRef.detectChanges();
    });
  }
}
